import { render } from "./mobileFaq.vue?vue&type=template&id=15c659f4&scoped=true&ts=true"
import script from "./mobileFaq.vue?vue&type=script&lang=ts"
export * from "./mobileFaq.vue?vue&type=script&lang=ts"

import "./mobileFaq.vue?vue&type=style&index=0&id=15c659f4&lang=scss&scoped=true"

import exportComponent from "/data/__qci/root-workspaces/__qci-pipeline-240633-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c659f4"]])

export default __exports__